(angular => {

  angular.module("FindRetailer", [
      "Config"
    ])

    .config(["$routeProvider", configRouter]);

  function configRouter($routeProvider) {
    $routeProvider
      .when("/findRetailer", {
        controller: "FindRetailer.IndexCtrl",
        controllerAs: "$ctrl",
        templateUrl: `admin/findRetailer/list/list.html`,
        role: ['admin', 'company_manager']
      });
  }

})(angular);
